import React from 'react';
import ErrorPage from '../components/ErrorPage/ErrorPage';

export default function Custom404() {
  return <ErrorPage title={'404'} text={'Page not found.'} />;
}
